import api from './axiosConfig';
const url = '/api/conductores';

// == Checklist dado su ID + ID de usuario que inicia sesión===============
/**
 * Obtener un registro de checklist de somnolencia por su ID. Incluye detalle completo.
 * @param {*} id_checklist Identificador del checklist Ej. 124
 * @returns Retorna los datos del checklist solicitado.
 */
export const obtenerCklSomnolencia = async (id_checklist) => {
  try {
    const response = await api.get(url+`/ver/ckl-somnolencia/${id_checklist}`, {
      withCredentials: true,
    });
    return response.data;
  }
  catch (error) {
    throw error.response?.data.msg || error;
  }
};
/**
 * Obtener un registro de checklist de vehículo por su ID. Incluye detalle completo.
 * @param {*} id_checklist 
 * @returns 
 */
export const obtenerCklVehiculo = async (id_checklist) => {
  try {
    const response = await api.get(url+`/ver/ckl-vehiculo/${id_checklist}`, {
      withCredentials: true,
    });

    return response.data;
  }
  catch (error) {
    throw error.response?.data.msg || error;
  }
};



// == Historico de Checklist ===============================================
/**
 * Obtener registros de checklists de somnolencia en un rango de fechas (detalle no incluido para optimizar carga).
 * @param {*} desde Fecha de inicio (YYYY-MM-DD)
 * @param {*} hasta Fecha de fin (YYYY-MM-DD)
 * @returns Datos encontrados en el periodo seleccionado o un array vacío.
 */
export const obtenerCklSomnolencias = async (desde, hasta) => {
  try {
    const response = await api.get(url+'/ver/ckl-somnolencia/periodo', {
      params: { desde, hasta },
      withCredentials: true,
    });
    return response.data.resultado || [];
  } 
  catch (error) {
    if (error.response && error.response.status === 403) {
      return { data: [], status: 403, message: error.response.data.msg  };
    } else {
      throw error.response?.data.msg || error;
    }
  }
};

/**
 * Obtener registros de checklists de vehículo en un rango de fechas (detalle no incluido para optimizar carga).
 * @param {*} desde Fecha de inicio (YYYY-MM-DD)
 * @param {*} hasta Fecha de fin (YYYY-MM-DD)
 * @returns 
 */
export const obtenerCklVehiculos = async (desde, hasta) => {
  try {
    const response = await api.get(url+'/ver/ckl-vehiculo/periodo', {
      params: { desde, hasta },
      withCredentials: true,
    });
    return response.data.cklVehiculo || [];
  } 
  catch (error) {
    if (error.response && error.response.status === 403) {
      return { data: [], status: 403, message: error.response.data.msg  };
    } else {
      throw error.response?.data.msg || error;
    }
  }
};

// ========================================================================
/**
 * Envia la información del checklist de somnolencia al servidor.
 * @param {*} data 
 * @returns 
 */
export const agregarCklSomnolencia = async (data) => {
  try {
    const response = await api.post(url+'/agregar/ckl-somnolencia', data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

/**
 * Envia la información del checklist de vehículo al servidor.
 * @param {*} data 
 * @returns 
 */
export const agregarCklVehiculo = async (data) => {
  try {
    const response = await api.post(url+'/agregar/ckl-vehiculo', data, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data.msg || error;
  }
};

// ========================================================================
export const obtenerMisSomnolencias = async (desde, hasta) => {
  try {
    const response = await api.get(url+'/ver/ckl-somnolencia/conductor', {
      params: { desde, hasta },
      withCredentials: true,
    });

    return response.data.resultado || [];
  }
  catch (error) {
    throw error.response?.data.msg || error;
  }
};

export const obtenerMisRevisionesVehiculares = async (desde, hasta) => {
  try {
    const response = await api.get(url+'/ver/ckl-vehiculo/conductor', {
      params: { desde, hasta },
      withCredentials: true,
    });
    
    return response.data.cklVehiculo || [];
  }
  catch (error) {
    throw error.response?.data.msg || error;
  }
};

// ========================================================================
export const notificarAlerta = async (cod_checklist, formData) => {
  try {
    const response = await api.post(
      url+`/enviar/alerta-checklist/${cod_checklist}`, 
      formData, 
      { 
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data'}
      });
    return { status: response.status, ...response.data };

  } catch (error) {
    throw error.response?.data.msg || error;;
  }
};